import React, { useEffect, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import "./PurchaseSubUsersModal.scss";
import Icon from "components/Elements/Icon/Icon.tsx";
import IncreaseDecreaseBox from "components/Elements/IncreaseDecreaseBox/IncreaseDecreaseBox.js";
import getFeatureBySystemName from "utils/getFeatures.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";


const PurchaseSubUsersModal = (props) => {

    const [amountOfUsers, setAmountOfUsers] = useState(props.userData.UserTotalSubUsersLicenses);
    const { getTextByKey, getLanguage } = useContent();
    const { closeModal } = useModal();
    const [feature, setFeature] = useState(null);
    const [priceOfSingleUser, setPriceOfSingleUser] = useState(0);
    const newCurrency = "ILS";

    useEffect(() => {
        getFeatureBySystemName("sub-users", getLanguage(), setFeature);
    },[])

    useEffect(() => {
        setPriceOfSingleUser(feature ? feature[newCurrency] : null)
    },[feature])

    const [symbolCurrnecy, setSymbolCurrnecy] = useState(
        newCurrency === "USD" ? "$" : newCurrency === "EUR" ? "€" : "₪"
    );

    return (
        // redirect to support until new billing is ready
        <div className="contact-us-support">
            <div className="title">
                {getTextByKey("contact-us-support-title")}
            </div>
            <div className="text">
                {getTextByKey("contact-us-support-text")}
            </div>
            <div className="button">
                <Button>
                    <LinkToNewTab
                        isNewTab={true}
                        page="contact-us?subject=sub-users"
                    >
                        {getTextByKey("contact-us-support-button-text")}
                    </LinkToNewTab>
                </Button>
            </div>
        </div>
        // <div className="purchase-sub-user-modal">
        //     <div className="title">
        //         {getTextByKey("purchase-sub-users-title-modal")}
        //     </div>
        //     <div className="content">
        //         <div className="manage-sub-user-amount-container">
        //             <Icon
        //                 name="sub-users-image"
        //                 iconClass="sub-user-image"
        //                 ext="png"
        //                 xxl
        //             />
        //             <div className="text-container">
        //                 <div className="title">
        //                     {getTextByKey("amount-of-sub-users-modal")}
        //                 </div>
        //                 <div className="price-per-user-modal">
        //                     {symbolCurrnecy}{priceOfSingleUser} {getTextByKey("price-per-user-modal")}
        //                 </div>
        //                 <div className="total-price-modal">
        //                     {getTextByKey("monthly-price-modal")} {symbolCurrnecy}{priceOfSingleUser * amountOfUsers} 
        //                 </div>
        //             </div>
        //             <IncreaseDecreaseBox
        //                 value={amountOfUsers}
        //                 setValue={setAmountOfUsers}
        //                 minValue={props.userData.UserTotalSubUsersLicenses - props.userData.UserAvailableSubUsersLicenses}
        //             />
        //         </div>
        //         <div className="sub-title">
        //             {getTextByKey("purchase-sub-users-sub-title-modal")}
        //         </div>
        //     </div>
        //     <div className="button-container">
        //     <Button 
        //             className="new-button"
        //             blank
        //             onClick={() => closeModal()}>
        //             {getTextByKey("purchase-sub-user-close")}
        //         </Button>
        //         <Button 
        //             className="new-button">
        //             {getTextByKey("purchase-sub-user-ok")}
        //         </Button>
        //     </div>
        // </div>

    );
};

export default PurchaseSubUsersModal;
